<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
            <span class="text-muted fw-light">Vendors /</span> Vendor List
        </h4>

        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right:10px">
                    people_alt
                </span>List of Vendors
            </mat-card-header>

            <mat-card class="mt-3">
                <mat-card-actions>
                    <div class="text-align">
                        <button class="createButton" mat-raised-button (click)="openDialog()"><i
                                class="material-icons">add</i> Add New
                            Vendor</button>
                    </div>

                    <div class="text-align mt-3">
                        <mat-form-field appearance="outline">
                            <mat-label>Search</mat-label>
                            <input matInput (keyup)="applyFilter($event)" #input>
                        </mat-form-field>
                    </div>
                </mat-card-actions>
                <alert></alert>
                <mat-card-content>
                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="navs-pills-justified-tablesuccess" role="tabpanel">
                            <div class="card">
                                <table mat-table [dataSource]="dataSource" matSort
                                    (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">

                                    <ng-container matColumnDef="srNo">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by srNo" class="heading" [resizeColumn]="true"
                                            [index]="0">S.No</th>
                                        <td mat-cell *matCellDef="let item; let j = index">
                                            {{ (j+1) + (myPaginator.pageIndex * myPaginator.pageSize) }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="vendorId">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by vendorId" class="heading"
                                            [resizeColumn]="true" [index]="1">Vendor Name</th>
                                        <td mat-cell *matCellDef="let element"> {{element.vendorId}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="email">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by email" [resizeColumn]="true" [index]="2">
                                            Email</th>
                                        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="phone">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by phone" class="heading" [resizeColumn]="true"
                                            [index]="3"> Phone Number</th>
                                        <td mat-cell *matCellDef="let element"> {{element.phone}} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef class="heading" [resizeColumn]="true"
                                            [index]="4">Login status</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span style="overflow: none;">
                                                <mat-checkbox color="primary" (change)="vendorLoginAccess(element)"
                                                    [(ngModel)]="element.isVendorLogin"></mat-checkbox>
                                            </span>
                                            <!-- <ng-template #elseBlock>Please click on edit button and fill the details to get the vendor login credentials.</ng-template> -->
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="editDetails">
                                        <th mat-header-cell *matHeaderCellDef class="heading" [resizeColumn]="true"
                                            [index]="5">Edit Vendor</th>
                                        <td mat-cell *matCellDef="let element">
                                            <a [routerLink]="['/All/editVendor',element.vendorRegistrationId]"
                                                style="text-decoration: none;">
                                                <i class="fa fa-pencil"></i> Edit</a>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <mat-card-actions>
                        <div class="text-align mt-3">
                            <mat-paginator #myPaginator [length]="25" [pageSize]="5"
                                [pageSizeOptions]="[5, 10, 25, 100]">
                            </mat-paginator>
                        </div>
                    </mat-card-actions>
                </mat-card-content>
            </mat-card>
        </mat-card>
    </div>
</div>
<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>